import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ReportService } from '../../services/report.service';
import { ReportList } from '../../classes/report-table';

@Component({
  selector: 'app-report-list',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './report-list.component.html',
  styleUrl: './report-list.component.css'
})
export class ReportListComponent implements OnInit {
  private readonly reportService = inject(ReportService);

  reportTree: ReportList = {};
  refineries: string[] = [];
  readonly expandedFolders = new Set<string>();
  loading = true;
  error = '';

  ngOnInit(): void {
    this.reportService.getReportList().subscribe({
      next: (data) => {
        this.reportTree = data ?? {};
        this.refineries = Object.keys(this.reportTree);
        this.loading = false;
      },
      error: (e) => {
        console.log(e);
        this.error = 'Failed to load reports.';
        this.loading = false;
      }
    });
  }

  toggleFolder(folder: string): void {
    if (this.expandedFolders.has(folder)) {
      this.expandedFolders.delete(folder);
    } else {
      this.expandedFolders.add(folder);
    }
  }

  isFolderExpanded(folder: string): boolean {
    return this.expandedFolders.has(folder);
  }

  getCategories(refinery: string): string[] {
    return Object.keys(this.reportTree[refinery] ?? {});
  }

  getReports(refinery: string, category: string): string[] {
    return this.reportTree[refinery]?.[category] ?? [];
  }

  displayName(name: string): string {
    return name.replace(/_/g, ' ');
  }

  getReportLink(refinery: string, category: string, report: string): string {
    return `/report/${refinery.replace(/ /g, '_')}/${category.replace(/ /g, '_')}/${report.replace(/ /g, '_')}`;
  }
}
